var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Uploaded to svgrepo.com",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M31.359,15.316L18.73,1.845c-0.206-0.22-0.466-0.318-0.722-0.318 C17.495,1.527,17,1.923,17,2.529V8H1C0.448,8,0,8.448,0,9v14c0,0.552,0.448,1,1,1h16v5.471c0,0.605,0.495,1.002,1.008,1.002 c0.255,0,0.516-0.098,0.722-0.318l12.629-13.471C31.719,16.299,31.719,15.701,31.359,15.316z M19,26.942V22H2V10h17V5.058L29.259,16 L19,26.942z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGo);
export default __webpack_public_path__ + "static/media/Go.11d5e3a4e469baedd2a8b61f131a19cb.svg";
export { ForwardRef as ReactComponent };